import React from 'react';
import { useLocation } from 'react-router-dom';

import { useConfig } from '@xingternal/hops';

import useScrollToHash from '../../hooks/useScrollToHash';
import CustomFrame from './../../Layouts/CustomFrame';
import HtmlHead from './../../Components/HtmlHead/HtmlHead';
import GdprImage from './../../Components/Illustrations/GdprImage';
import PageviewTracker, {
  PROP_CHANNEL,
} from '../../Components/PageviewTracker/PageviewTracker';
import useCookieConsent from './../../contexts/useCookieConsent';
import ContentSection from './ContentSection/ContentSection';
import HeaderSection from './HeaderSection/HeaderSection';
import DownloadAppSection from './DownloadAppSection/DownloadAppSection';
import CtaSection from './CtaSection/CtaSection';

import jobsIllustration from './images/jobs.svg';
import lebenslaufIllustration from './images/lebenslauf.svg';
import networkIllustration from './images/network.svg';

import { GdprWrapper } from './Start.style';

const Start = () => {
  useScrollToHash();
  const { externalUrl, externalLoginUrl } = useConfig();
  const { search } = useLocation();
  const loginUrl = new URL(search, externalLoginUrl).toString();
  const signUpUrl = `${externalUrl}/start/signup`;
  const signUpActionName = 'losp_sign_up_button_click';
  const headerSignUpTrackingParams = `sc_o=${signUpActionName}&sc_o_PropActionOrigin=${signUpActionName}_header`;

  useCookieConsent();

  return (
    <React.Fragment>
      <HtmlHead pageName={'startPage'}>
        <link rel={'canonical'} href={externalUrl} />
      </HtmlHead>
      <PageviewTracker
        pageName={`${PROP_CHANNEL}/start/index`}
        context={{
          PropContextDimension1: 'welcome_lo_startpage_signup_view',
        }}
      />
      <CustomFrame
        signupLink={`${signUpUrl}?${headerSignUpTrackingParams}`}
        loginLink={loginUrl}
        withDirectoryNavigations
      >
        <main>
          <HeaderSection />
          <ContentSection
            headlineTranslationId="WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TITLE"
            headlineTranslationDefaultMessage="On XING, you're more than just your CV"
            textTranslationId="WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_TEXT"
            textTranslationDefaultMessage="Whether it's a change of city, lifestyle or just wanting something new – on XING it’s all about who you want to be in your working life. Let the real you shine through."
            imageSrc={lebenslaufIllustration}
            imageAltTranslationId="WELCOME_STARTPAGE_JOBS_VERSION_SECTION_ONE_IMG_ALT"
          />
          <ContentSection
            imageOnTheRight={true}
            headlineTranslationId="WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TITLE"
            headlineTranslationDefaultMessage="1.5 mill jobs and countless opportunities"
            textTranslationId="WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_TEXT"
            textTranslationDefaultMessage="Imagine a gallery of amazing jobs where you receive suggestions tailored to your preferences. Find out what you really want from your working life: how do you want to develop? Which employers do you like? What company culture do you want to be part of?"
            imageSrc={jobsIllustration}
            imageAltTranslationId="WELCOME_STARTPAGE_JOBS_VERSION_SECTION_TWO_IMG_ALT"
          />
          <ContentSection
            headlineTranslationId="WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TITLE"
            headlineTranslationDefaultMessage="Reach out to the right people"
            textTranslationId="WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_TEXT"
            textTranslationDefaultMessage="Over 23,000 recruiters on XING are just a message away. Get in touch with HR, industry and labour market experts, and personally contact recruiters and employees at your dream company. Join us and do your XING!"
            imageSrc={networkIllustration}
            imageAltTranslationId="WELCOME_STARTPAGE_JOBS_VERSION_SECTION_THREE_IMG_ALT"
          />
          <CtaSection />
          <DownloadAppSection />
        </main>
        <GdprWrapper>
          <GdprImage />
        </GdprWrapper>
      </CustomFrame>
    </React.Fragment>
  );
};

export default Start;
